import React from 'react';
import { Text } from '../../Text/Text.js';
import { useMenuContext } from '../Menu.context.js';
import useStyles from './MenuLabel.styles.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function MenuLabel(props) {
  const { classNames, styles } = useMenuContext("Menu.Label");
  const { classes } = useStyles(null, { name: "Menu", classNames, styles });
  return /* @__PURE__ */ React.createElement(Text, __spreadValues({
    className: classes.label
  }, props));
}
MenuLabel.displayName = "@mantine/core/MenuLabel";

export { MenuLabel };
//# sourceMappingURL=MenuLabel.js.map
